// Import lib/features
import 'lib/lightbox'
import 'lib/load-content'
import 'lib/append-client-id'

// Development only hot module replacement.
if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept()
}
